export const INBOX_MESSAGES_NEW = 'inbox.MESSAGES_NEW';
export const INBOX_NEW_MONTH_MESSAGES = 'inbox.NEW_MONTH_MESSAGES';
export const INBOX_MESSAGES_READ = 'inbox.MESSAGES_READ';
export const INBOX_MESSAGES_PROCESSED_UPDATE = 'inbox.MESSAGES_PROCESSED_UPDATE';

export const INBOX_READ_ALL_MESSAGES = 'inbox.READ_ALL_MESSAGES';

export const INBOX_FETCH_MESSAGES_SUCCESSFUL = 'inbox.FETCH_MESSAGES_SUCCESSFUL';
